<template>
  <div id="grid-revision">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-toolbar card color="white">
        <v-toolbar-title class="indigo--text"
          >Revision de Materiales</v-toolbar-title
        >
      </v-toolbar>
      <v-layout>
        <carga-masiva
          v-if="
            (usuarioLoggedTipe == 'PROVEEDOR' ||
              usuarioLoggedTipe == 'ADMINISTRADOR') &&
            getCodigoPerfil() != 'LEC' && !isContratoCerrado()
          "
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
        ></carga-masiva>
      </v-layout>
      <v-layout v-if="tabSelected == 'Registro Avances'" justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="centroValue"
            :items="centroSelect"
            label="Centro"
            data-vv-name="listaCentros"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            label="Nivel"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="materialValue"
            :items="materialSelect"
            label="Material"
            item-text="name"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="fechaValue"
            :items="fechaSelect"
            label="Fecha"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="resultadoValue"
            :items="resultadoSelect"
            label="Resultado"
          ></v-select>
        </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="filterCenter()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <!-- BOTON NO INCLUIDO EN DISEÑO DEBERIA ESTAR -->
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout v-if="tabSelected == 'Evolucion'" justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="regionValue"
            :items="regionSelect"
            label="Region"
            item-text="name"
            item-value="code"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            label="Nivel"
          ></v-select>
        </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="filterEvolucion()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <!-- BOTON NO INCLUIDO EN DISEÑO DEBERIA ESTAR -->
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-data-table
            v-if="tabSelected == 'Registro Avances'"
            :key="tableAvances"
            :headers="headers"
            :items="itemsRevision"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">
                {{ props.item.centroAcopio.codCentro }}
              </td>
              <td class="text-xs-left">{{ props.item.nivel }}</td>
              <td class="text-xs-left">{{ props.item.rbd }}</td>
              <td class="text-xs-left">{{ props.item.curso }}</td>
              <td class="text-xs-left">{{ props.item.cajaContenedora }}</td>
              <td class="text-xs-left">{{ props.item.fechaRevision }}</td>
              <td class="text-xs-left">
                {{ props.item.revisionResultado.descripcion }}
              </td>
              <td class="text-xs-left">{{ props.item.sMotivoError }}</td>
              <div class="text-xs-center">
                <td>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Consultar detalle"
                    @click="viewRevision(props.item.id)"
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="
                      (usuarioLoggedTipe == 'PROVEEDOR' ||
                        usuarioLoggedTipe == 'ADMINISTRADOR') &&
                      getCodigoPerfil() != 'LEC' && !isContratoCerrado()
                    "
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                    title="Modificar detalle"
                    @click="editRevision(props.item.id)"
                  >
                    <v-icon>open_in_new</v-icon>
                  </v-btn>
                </td>
              </div>
            </template>
          </v-data-table>
          <v-data-table
            v-if="tabSelected == 'Evolucion'"
            :headers="headers"
            :items="itemsRevision"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.sRegion }}</td>
              <td class="text-xs-left">{{ props.item.nivel }}</td>
              <!-- <td class="text-xs-left">{{ props.item.tipoMaterial }}</td> -->
              <td class="text-xs-left">{{ props.item.numeroCursos }}</td>
              <td class="text-xs-left">{{ props.item.cursosRevisados }}</td>
              <td class="text-xs-left">
                {{ props.item.porcentajeCursosRevisados }}
              </td>
              <td class="text-xs-left">{{ props.item.cursosOk }}</td>
              <td class="text-xs-left">
                {{ props.item.porcentajeCursosRevisadosOk }}
              </td>
              <td class="text-xs-left">{{ props.item.cursosNok }}</td>
              <td class="text-xs-left">
                {{ props.item.porcentajeCursosRevisadosNok }}
              </td>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA PROVEEDORES -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template v-if="tabSelected == 'Registro Avances'">
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                  >
                    <v-icon>remove_red_eye</v-icon> </v-btn
                  >&nbsp;Consultar detalle
                </template>

                <template
                  v-if="
                    tabSelected == 'Registro Avances' &&
                    (usuarioLoggedTipe == 'PROVEEDOR' ||
                      usuarioLoggedTipe == 'ADMINISTRADOR') &&
                    getCodigoPerfil() != 'LEC' && !isContratoCerrado()
                  "
                >
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                  >
                    <v-icon>open_in_new</v-icon> </v-btn
                  >&nbsp;Modificar detalle
                </template>
              </td>
            </div>
          </v-card-actions>
          <!--fin iconos leyenda--><!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import CargaMasiva from "@/components/CargaMasiva.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-revision",
  components: {
    Loading,
    LoadingDescarga,
    CargaMasiva,
  },
  mixins: [misMixins],
  props: {
    rowsTable: "",
  },

  data() {
    return {
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      botonValida: 1,
      botonProcesar: false,
      botonCargar: true,
      loading1: false,
      alerta: false,
      respOk: false,
      botonDescarga: false,
      dialogArchivo: false,
      dialogLoading: false,
      loading: false,
      dialog: false,
      idEstado: "",
      contratoId: "",
      itemsRevision: [],
      headers: [],
      fechaInicioValue: [],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsMateriales: [],
      centroValue: null,
      centroSelect: [],
      regionValue: null,
      regionSelect: [],
      nivelValue: null,
      nivelSelect: [],
      tipoMaterialValue: null,
      tipoMaterialSelect: [],
      materialValue: null,
      materialSelect: [],
      fechaValue: null,
      fechaSelect: [],
      resultadoValue: null,
      resultadoSelect: [],
      filter: false,
      tabSelected: "",
      tableAvances: 10,
      tableEvolucion: 20,
      tipeArchive: "",
      resp: "",
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
    };
  },
  created() {
    this.loading = true;
    this.tipeArchive = ".xlsx";
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.tabSelected = this.$store.getters.subTabSelectedStored;

    //se indican las apis a utilizar
    this.apiValidateDocument = "/revisionMaterial/readFile";
    this.apiSaveDocument = "/revisionMaterial/cargaMasiva";
    this.apiDownloadDocument = "/revisionMaterial/download/";
    this.templateTitle = "Planilla_Revision";

    if (this.tabSelected == "Registro Avances") {
      this.headerAvance();
      this.loadDataAvances();
      this.tableAvances += 11;
    }
    if (this.tabSelected == "Evolucion") {
      this.headerEvolucion();
      this.loadDataEvolucion();
      this.tableEvolucion += 21;
    }
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },

  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    headerAvance() {
      this.headers = [
        { text: "Centro", align: "left", sortable: false, value: "centro" },
        { text: "Nivel", sortable: false, value: "nivel" },
        { text: "RBD", sortable: false, value: "rbd" },
        { text: "Curso", sortable: false, value: "curso" },
        { text: "Caja Contenedora", sortable: false, value: "cajaContenedora" },
        { text: "Fecha", sortable: false, value: "fecha" },
        { text: "Resultado", sortable: false, value: "resultado" },
        { text: "Motivo Error", sortable: false, value: "motivoError" },
        { text: "Accion", sortable: false, value: "accion" },
      ];
    },
    headerEvolucion() {
      this.headers = [
        { text: "Region", align: "left", sortable: false, value: "region" },
        { text: "Nivel", sortable: false, value: "nivel" },
        { text: "N° Total", sortable: false, value: "numeroMaterialesTotales" },
        {
          text: "N° Revisado",
          sortable: false,
          value: "numeroMaterialesRevisados",
        },
        { text: "% Revisado", sortable: false, value: "porcentajeRevisado" },
        {
          text: "N° Sin Error",
          sortable: false,
          value: "numeroMaterialesConError",
        },
        {
          text: "N° Con Error",
          sortable: false,
          value: "numeroMaterialesSinError",
        },
        {
          text: "% Correctos",
          sortable: false,
          value: "porcentajeMaterialesCorrectos",
        },
        {
          text: "% Incorrectos",
          sortable: false,
          value: "porcentajeMaterialesIncorrectos",
        },
      ];
    },

    openRevision(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormRevision",
          params: { tipeView: "crear", titleViewRevision: "Nueva Revision" },
        });
      }, 1000);
    },

    viewRevision(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormRevision",
          params: {
            idRevision: id,
            tipeView: "consulta",
            titleViewRevision: "Consulta de Revision",
          },
        });
      }, 1000);
    },

    editRevision(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormRevision",
          params: {
            idRevision: id,
            tipeView: "modifica",
            titleViewRevision: "Edicion de Revision",
          },
        });
      }, 1000);
    },

    viewObservacion(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormObservacion",
          params: { idCentro: id, tipeView: "consulta" },
        });
      }, 1000);
    },
    editObservacion(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormObservacion",
          params: { idCentro: id, tipeView: "modifica" },
        });
      }, 1000);
    },

    async loadRevisionFilter() {
      let that = this;
      let subTab = this.$store.getters.subTabSelectedStored;
      let proceso = this.$store.getters.proSelectedStored;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        codentroAcopio:
          this.centroValue && this.centroValue != null
            ? this.centroValue
            : null,
        sRevisionResultado:
          this.resultadoValue && this.resultadoValue != null
            ? this.resultadoValue
            : null,
        tipoMaterial:
          this.materialValue && this.materialValue != null
            ? this.materialValue
            : null,
        nivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        fechaRevision:
          this.fechaValue && this.fechaValue != null ? this.fechaValue : null,
        idContrato: idContrato,
      };
      return await axios

        .post("/revisionMaterial/filters", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    async loadDataAvances() {
      this.loading = true;
      this.itemsRevision = await this.loadRevisionFilter();
      this.miPaginacion.totalItems = this.itemsRevision.length;

      if (this.itemsRevision.length > 0) {
        this.$parent.$parent.hasRows = true;
      }
      this.loading = false;
      if (this.itemsRevision.length > 0) {
        this.loadCentroSelect();
        this.loadNivelSelect();
        this.loadMaterialSelect();
        this.loadFechaSelect();
        this.loadResultadoSelect();
      }
    },
    async loadRevisionEvolucion() {
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        tipoPrueba:
          this.tipoPruebaValue && this.tipoPruebaValue != null
            ? this.tipoPruebaValue
            : null,
        nivel:
          this.nivelValue && this.nivelValue != null ? this.nivelValue : null,
        idregion:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        sRegion:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        idContrato: idContrato,
      };
      return await axios
        .post("/revisionMaterial/evolucion/all", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    async loadDataEvolucion() {
      this.loading = true;
      this.itemsRevision = await this.loadRevisionEvolucion();
      this.miPaginacion.totalItems = this.itemsRevision.length;
      this.loading = false;

      if (this.itemsRevision.length > 0) {
        this.loadRegionSelect();
        this.loadNivelSelect();
      }
    },

    loadCentroSelect() {
      let reg = [];
      this.itemsRevision.forEach(function (c) {
        let index = reg.findIndex(
          (x) => x.centroAcopio == c.centroAcopio.codCentro
        );
        if (index === -1) {
          reg.push(c.centroAcopio.codCentro);
        }
      });
      this.centroSelect = reg;
    },

    loadComunaSelect() {
      let com = [];
      this.itemsRevision.forEach(function (c) {
        let index = com.findIndex((x) => x.comuna == c.comuna.nombre);
        if (index === -1) {
          com.push(c.comuna.nombre);
        }
      });
      this.comunaSelect = com;
    },
    loadNivelSelect() {
      let est = [];
      this.itemsRevision.forEach(function (c) {
        let index = est.findIndex((x) => x.nivel == c.nivel);
        if (index === -1) {
          est.push(c.nivel);
        }
      });
      this.nivelSelect = est;
    },

    loadRegionSelect() {
      let reg = [];
      this.itemsRevision.forEach(function (d) {
        if (d.idregion != null) {
          let index = reg.findIndex((x) => x.code == d.idregion);
          if (index === -1) {
            if (d.idregion != null && d.idregion != "") {
              reg.push({
                name: d.sRegion,
                code: d.idregion,
              });
            }
          }
        }
      });
      this.regionSelect = reg;
    },
    loadMaterialSelect() {
      let reg = [];
      this.itemsRevision.forEach(function (d) {
        if (d.idMaterial != null) {
          let index = reg.findIndex((x) => x.code == d.idMaterial);
          if (index === -1) {
            if (d.idMaterial != null && d.idMaterial != "") {
              reg.push({
                name: d.tipoMaterial,
                code: d.idMaterial,
              });
            }
          }
        }
      });
      this.materialSelect = reg;
    },
    loadFechaSelect() {
      let est = [];
      this.itemsRevision.forEach(function (c) {
        let index = est.findIndex((x) => x.fechaRevision == c.fechaRevision);
        if (index === -1) {
          est.push(c.fechaRevision);
        }
      });
      this.fechaSelect = est;
    },
    loadResultadoSelect() {
      let est = [];
      this.itemsRevision.forEach(function (c) {
        let index = est.findIndex(
          (x) => x.revisionResultado == c.revisionResultado.descripcion
        );
        if (index === -1) {
          est.push(c.revisionResultado.descripcion);
        }
      });
      this.resultadoSelect = est;
    },

    clear() {
      this.regionValue = "";
      this.centroValue = "";
      this.nivelValue = "";
      this.materialValue = "";
      this.fechaValue = "";
      this.resultadoValue = "";
      if (this.tabSelected == "Registro Avances") {
        this.headerAvance();
        this.loadDataAvances();
        this.tableAvances += 11;
      }
      if (this.tabSelected == "Evolucion") {
        this.headerEvolucion();
        this.loadDataEvolucion();
        this.tableEvolucion += 21;
      }
    },
    //SOLO NUMEROS
    bloqueoEdicion(tip) {
      if (tip == "AGENCIA") {
        this.bloqueo = true;
      }
      if (tip == "PROVEEDOR") {
        this.bloqueo = false;
      }
      return this.bloqueo;
    },

    filterCenter() {
      this.filter = true;
      this.loadDataAvances();
    },

    filterEvolucion() {
      this.filter = true;
      this.loadDataEvolucion();
    },
  },
};
</script>